import alertify from "alertifyjs";

(function ($) {
  $.sortableGridView = function (options) {
    const defaultOptions = {
      id: "sortable-grid-view",
      action: "sortItem",
      moveItem: "",
      csrfTokenName: "",
      csrfToken: "",
    };

    $.extend({}, defaultOptions, options);

    $("#" + options.id + " .sortable-grid-view tbody").sortable({
      cursor: "move",
      handle: options.moveItem,

      start: function (e, ui) {
        $(this).attr("data-previndex", ui.item.index());
      },

      update: function (event, ui) {
        const newPosition = ui.item.index();
        const oldPosition = $(this).attr("data-previndex");
        const itemId = $(ui.item[0]).attr("data-itemid");

        const serial = [];

        $("#" + options.id + " .sortable-grid-view tbody.ui-sortable tr").each(
          function () {
						const key = $(this).data("key");
						if (key) {
							serial.push(key);
						}
          }
        );

				const tableSortEvent = new CustomEvent("table-sort", {detail: {itemsOrder: serial, tableId: options.id}});
				document.dispatchEvent(tableSortEvent);

        $.ajax({
          url: options.action,
          type: "post",
          dataType: "json",
          data: {
            data: serial,
            item_id: itemId,
            old_position: oldPosition,
            new_position: newPosition,
          },
          success: function (data) {
            if (!data.success) {
              alertify.error(data.error);
            }
          },
          error: function (data) {
            console.log(data.error);
          },
        });
      },
    });
  };

  $.modalWindow = function (columnNames) {
    const modalWindow =
      '<div id="dialog" title="Edit comment" style="display: none"><textarea class="form-control" rows="5"></textarea></div>';
    $("table").append(modalWindow);

    columnNames.forEach((name) => {
      $(`table [name*='[${name}]']`).on("click", (e) => {
        const dialog = $("#dialog");
        dialog.attr("title", `Edit ${name}`);

        dialog.dialog({
          modal: true,
          position: { my: "right top", at: "left bottom", of: e.target },
          show: {
            effect: "blind",
            duration: 200,
          },
          hide: {
            effect: "clip",
            duration: 200,
          },
          beforeClose: function (event, ui) {
            const target = $(e.target);
            const dialogTextArea = $(this).find("textarea");

            if (target[0].value !== dialogTextArea[0].value) {
              target[0].title = dialogTextArea[0].value;
              target[0].value = dialogTextArea[0].value;
              target.trigger("change");
            }
          },
          open: function (event, ui) {
            $(".ui-widget-overlay").click(function () {
              $("#dialog").dialog("close");
            });

            $(this).find("textarea")[0].value = $(e.target)[0].value;
          },
        });
      });
    });
  };
})(jQuery);
